import script from "./App.vue?vue&type=script&lang=ts&setup=true&async=true"
export * from "./App.vue?vue&type=script&lang=ts&setup=true&async=true"

const __exports__ = script;

export default __exports__